import { EnderecoParmDTO } from "./address";
import { BaseFiltroPagDTO } from "./base-dto";

export class PropostaFreteSolicParmDTO {
  idUnidade: number;
  idPaciente: number;
  mudancaDefinitiva: boolean;
  dataInicioMudanca: string;
  dataFimMudanca: string;
  tpBolsaCompart: boolean;
  endereco: EnderecoParmDTO;
  horarioEntrega: string;
}

export class SolicitacaoFiltroPagDTO extends BaseFiltroPagDTO {
  idUnidade: number;
  idLoginSolicitante: number;
  idPaciente: number;
  situacoes: string[];
  dataSolicIni: string;
  dataSolicFim: string;

  logradouro: string;
  numero: string;
  bairro: string;
  municipio: string;
  estado: string;

  bolsaMulti: boolean;
}

export class AnaliseFiltroPagDTO extends SolicitacaoFiltroPagDTO {
  statusAnalise: string;
}

export class AnaliseParmDTO {
  chave: string;
  rejeitado: boolean;
  justificativa: string;
  cotacoes: CotacaoParmDTO[];
  endereco: EnderecoParmDTO;
}

export class CotacaoParmDTO {
  horarioLimitePrescricao: string;
  horarioLimiteEntrega: string;
  custoEntrega: number;
  descricao: string;
}

export class PropostaAprovacaoParmDTO {
  chave: string;
  idPropostaAceita: number;
  propostaAceita: boolean;
  motivo: string;
}

export class PropostaEfetivacaoParmDTO {
  chave: string;
  efetivar: boolean;
  motivo: string;
}

export class PacientePropostaFreteDTO {
  id: number;
  nome: string;
  showTpMudancaEndereco: boolean;
}

export const SITUACAO_PENDENTE_ANALISE = 'PA';
export const SITUACAO_PENDENTE_APROVACAO = 'AN';
export const SITUACAO_PENDENTE_EFETIVACAO = 'PE';


export const SITUACOES_SOLICITACOES_PENDENTES = [SITUACAO_PENDENTE_ANALISE, SITUACAO_PENDENTE_APROVACAO, SITUACAO_PENDENTE_EFETIVACAO]
